var zoom =
webpackJsonp_name_([7],{

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(564);

__webpack_require__(565);

__webpack_require__(473);

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ZoomButtonsControl;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _lbsPiDash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lbsPiDash);

var _browserCompatibility = __webpack_require__(26);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    layout: { 'divClass': _defines2.default.clsDIVZOOMCTL, 'precinct': 'BL', 'order': 1 }
};

function ZoomButtonsControl(uScope, viewport) {
    var self = this;
    var isLoaded = false; // zoom button control has been loaded

    var jVpDiv = viewport.vpDivGet('outer');
    var jZoomCtlDiv;
    var jZoomButtons;
    var jZoomButton;

    var prefVisibleDef = true; // zoom button visibility preference default

    var navModesImHiddenIn = {}; // what navigation modes not to display the zoom control

    var layout = _.clone(defaults.layout); // zoom button layout info, clone the global set so I can modify it
    var reLayout = viewport.overLayout.refreshPrecinct;

    //............................................ construct_ local
    var construct_ = function construct_() {
        if (_defines2.default.ENABLEZOOMCTL == false) return;

        navModesImHiddenIn[_defines2.default.eNavModes.nmRasterScan] = true; // hide zoom buttons in rasterscan mode
        _defines2.default.setAnnotNavModes(navModesImHiddenIn); // hide zoom buttons when drawing any annotation

        load_(); // load the zoom button control
    };

    //............................................ show() public
    this.show = function (show) {
        if (isLoaded == false) return;
        // prevent show if preference is not to show
        if (uScope.prefGet(_defines2.default.clsDIVZOOMCTL) == false) jZoomCtlDiv.hide();else if (show == true) jZoomCtlDiv.show();else jZoomCtlDiv.hide();

        reLayout(layout.precinct); // layout just this overlay's precinct
    };
    //............................................ lightButton() public
    // This function lights the zoom button according to the zoom of the image
    //    If the image's zoom is not one of the zoom button values, all buttons are un-lit.
    //
    //    This function is necessary because the zoom control buttons must un-light if the current zoom
    //    is not a fixed zoom and because they must light if any of the means to change the zoom other
    //    than the zoomButton control changes the zoom. Also, in multi-image clicking a zoom button
    //    on one image seems to clear the active setting on all zoom buttons.
    //
    //    improvements: This just doesn't seem to be the best way to resolve the issues,
    //            possible rework http://api.jquery.com/val/

    this.lightButton = function () {
        if (_defines2.default.ENABLEZOOMCTL == false) return;

        jZoomButton.removeClass('ui-state-active'); // remove active state from all buttons
        var zoom = viewport.getViewZoom();
        var fixedZooms = viewport.getFixedZoomArray();
        for (var z = 0, len = fixedZooms.length; z < len; z++) {
            // find the index in the fixed zoom array of this zoom
            if (fixedZooms[z].zoom == zoom) {
                // if found, there is an associated zoom button
                var jLabel = jZoomButton[2 * z + 1]; // get the label associated with this zoom
                $(jLabel).addClass('ui-state-active'); // and add the active state to it
                break;
            }
        }
        if (z === fixedZooms.length) {
            // if the zoom is none of the fixed mags
            jZoomButton.removeClass('ui-state-active'); // remove active state from all buttons
        }
    };

    //............................................ load_() local
    var load_ = function load_() {
        if (jZoomCtlDiv) return;

        // first create an offscreen div that will contain the zoom control
        jZoomCtlDiv = $('<div/>', { // build the div tag that contains the zoom control
            'class': _defines2.default.clsDIVZOOMCTL + ' ' + _defines2.default.clsOVERLAY, // overlay class sets the z-index
            css: { 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX }
        });

        jZoomButtons = $('<div/>', { 'class': _defines2.default.clsDIVZOOMBTNS }); // zoom button container div

        if (_browserCompatibility.env.isIOS) // ios make buttons bigger by increasing the font for ios
            jZoomButtons.addClass('ios');

        var fixedZooms = viewport.getFixedZoomArray();
        for (var l = 0, zlen = fixedZooms.length; l < zlen; l++) {
            var id = 'zoom' + l + Math.random().toString().replace('.', ''); // generate a unique id for each zoom button
            jZoomButton = $('<input/>', { 'class': _defines2.default.clsDIVZOOMBTN, 'type': 'radio', 'id': id, 'name': 'radio' });

            var mag = l == 0 ? 'Fit' : fixedZooms[l].mag;
            var color = _defines2.default.objectiveColor(mag); // get color related to this magnification

            var text = l == 0 ? 'Fit' : mag + 'x'; // set label text
            if (l == fixedZooms.length - 1) {
                // initially check the first mag //cp-maybe an option - match with initial zoom state in vpView
                jZoomButton.attr('checked', 'checked');
            }
            // the zoom button label is either a numeric mag like "1.25x" or it is"Fit"
            var jZoomLabel = $('<label/>', { 'class': _defines2.default.clsDIVZOOMBTN, 'for': id, 'text': text });

            var jElement = _defines2.default.DOVERTICALZOOMCTL == true ? $('<div/>') : $('<span/>');
            if (_defines2.default.DOZOOMCOLOR) jElement.css({ 'border-left': '4px solid', 'border-color': color }); // left bar color code
            jElement.append(jZoomButton); // add this button to the div
            jElement.append(jZoomLabel); // add this label to the div
            jZoomButtons.append(jElement); // add the div to the button container
        }
        jZoomCtlDiv.append(jZoomButtons); // add the button container to the zoom control

        jVpDiv.append(jZoomCtlDiv); // place the zoom control div in the vp
        jZoomButtons = jVpDiv.find('.' + _defines2.default.clsDIVZOOMBTNS);
        jZoomButton = jVpDiv.find('.' + _defines2.default.clsDIVZOOMBTN);

        jZoomButtons.buttonset(); // initialize the buttonset
        viewport.overLayout.add(layout); // and call into layout with parms to place the div

        isLoaded = true;
        self.show(true); // show/hide according to user preferences
        bindEvents_(); // add event handlers
        return;

        //..................................................
        // closure functions
        //............................................ bindEvents_()
        // bindEvents_ - This function adds the zoom button control event handlers.
        //
        //    Note that by using the same namespace as the viewport when the
        //    viewport removes its events by namespace, these are also removed.

        function bindEvents_() {
            var namespace = viewport.eventNameSpaceGet();

            // show/hide zoom buttons on mode change
            $(_defines2.default.idHashROOT).on(_defines2.default.evMODECHANGE + namespace, function (e, parms) {
                // show is true if this is the image selected and not in a mode that I'm supposed to hide during
                var bshow = viewport.getImageIdx() == uScope.getSelImageIdx() && navModesImHiddenIn[parms.navMode] == undefined ? true : false;
                self.show(bshow);
            });
            viewport.renderer.addLayer({
                zoomChange: self.lightButton
            });

            // show/hide zoom buttons if image is selected/not-selected
            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
                self.show(parms.uScopeIdx == viewport.getImageIdx());
            });
            // user preference update
            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSREADY + namespace, function (e, parms) {
                self.show(uScope.prefGet(_defines2.default.clsDIVZOOMCTL));
            });
            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSET + namespace, function (e, parms) {
                // parms: {className: STR, value: bool}
                if (parms.className == _defines2.default.clsDIVZOOMCTL) {
                    self.show(parms.value);
                }
            });
            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTVISIBLE + namespace, function (e, parms) {
                uScope.prefSet(_defines2.default.clsDIVZOOMCTL, prefVisibleDef);
            });

            // mouse, ...
            jZoomButton.on('mousedown' + namespace + ' mousemove' + namespace + '  mouseup' + namespace + '  mouseleave' + namespace, function (e) {
                return false; // because these events propigate to the vp and starts dragging, etc the image, intercept them
            });
            jZoomButton.on('click' + namespace, function (e) {
                click_(e);
                return false;
            });
        }
        //..................................................
    };
    //............................................ click_() local
    //    This function is the fixed zoom button click handler.
    //    If you only want to light a fixed zoom button, call lightButton
    var click_ = function click_(e) {
        var magx = $(e.currentTarget).text(); // determine what zoom value was selected; returns magnification with x, e.g. "5x" or "2x" or "Fit"
        var mag = magx !== 'Fit' ? parseFloat(magx) : viewport.getFitMag(); // remove the x : convert "Fit" to mag value

        // Note: it is very IMPORTANT to exit if you're already at this mag b/c vp's zoom click can cycle back to zm_click otherwise
        // that is, without this infinite recursion will happen, stack overflow, bad things like that
        if (mag == viewport.getViewMag()) // if already viewing at this magnification, nothing to do
            return;

        if (_browserCompatibility.env.isIOS) {
            // iOS does not light the active button nor dim the inactive button automatically
            jZoomButton.removeClass('ui-state-active'); // remove active state from all buttons
            $(e.currentTarget).addClass('ui-state-active'); // add active state to this zoom button
        }

        var zoom = magx !== 'Fit' ? viewport.convertToZoom(mag) : 'Fit'; // note - for fit zoom zoomAbsolute can take the string 'Fit'
        viewport.zoomAbsolute(zoom); // execute the zoom and indicate the zoom is a click event
    };

    //............................................ construction
    construct_();
}
module.exports = exports['default'];

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _zoomSliderControl = __webpack_require__(474);

var _zoomSliderControl2 = _interopRequireDefault(_zoomSliderControl);

var _zoomButtonsControl = __webpack_require__(472);

var _zoomButtonsControl2 = _interopRequireDefault(_zoomButtonsControl);

var _publicApi = __webpack_require__(6);

var _publicApi2 = _interopRequireDefault(_publicApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var zoomButtonLoader = {
    name: 'us:zoom-button',

    extends: 'viewport',

    constructor: _zoomButtonsControl2.default
};

var zoomSliderLoader = {
    name: 'us:zoom-slider',

    extends: 'viewport',

    // Required because to assist with... sizing of the UI? TODO: Remove this bizarre dependency.
    dependencies: ['us:zoom-button'],

    constructor: _zoomSliderControl2.default
};

_publicApi2.default.plugins.register(zoomButtonLoader);
_publicApi2.default.plugins.register(zoomSliderLoader);

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ZoomSliderControl;

var _defines = __webpack_require__(0);

var _defines2 = _interopRequireDefault(_defines);

var _lbsPiDash = __webpack_require__(5);

var _ = _interopRequireWildcard(_lbsPiDash);

var _helpers = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaults = {
    layout: { 'divClass': _defines2.default.clsDIVZOOMSLIDER, 'precinct': 'BL', 'rightOffset': 12, 'order': 0 }
};

function ZoomSliderControl(uScope, viewport) {
    var self = this;
    var isLoaded = false; // zoom slider has been loaded
    var isActive = false; // Zoom slider is being used to set zoom

    var jVpDiv = viewport.vpDivGet('outer');
    var jZoomSliderDiv;

    var prefVisibleDef = true; // zoom slider visibility preference default

    var navModesImHiddenIn = {}; // what navigation modes not to display the zoom slider control

    var layout = _.clone(defaults.layout); // zoom slider layout info, clone the global set so I can modify it
    var reLayout = viewport.overLayout.refreshPrecinct;

    //............................................ construct_ local
    var construct_ = function construct_() {
        if (_defines2.default.ENABLEZOOMCTL == false || _defines2.default.ENABLEZOOMSLIDER == false) return;
        if (_defines2.default.DOVERTICALZOOMCTL == false) {
            // ('Slider control not coded for horizontal yet!'); // eslint-disable-line no-undef
            return;
        }

        navModesImHiddenIn[_defines2.default.eNavModes.nmRasterScan] = true; // hide zoom slider in rasterscan mode
        _defines2.default.setAnnotNavModes(navModesImHiddenIn); // hide zoom slider when drawing any annotation

        load_(); // load the zoom slider
    };
    //............................................ show() public
    this.show = function (show) {
        if (isLoaded == false) return;

        // prevent show if preference is not to show
        if (uScope.prefGet(_defines2.default.clsDIVZOOMSLIDER) == false) jZoomSliderDiv.hide();else if (show == true) jZoomSliderDiv.show();else jZoomSliderDiv.hide();

        reLayout(layout.precinct); // layout just this overlay's precinct
    };

    //............................................ enable() public
    //    This function enables the zoom slider control which is disabled when the slider stops
    //    to prevent slider changes while image is being resolved.
    this.enable = function () {
        if (!isLoaded) {
            return;
        }
        if (jZoomSliderDiv.is(':visible')) {
            jZoomSliderDiv.slider('enable');
        }
    };

    //............................................ load_() local
    //    This function builds the zoom slider control and calls into the layout manager
    //         to position it according to its layout settings.
    //    Note that the sizing of the slider uses the fixed zoom control so it must be created first.
    //    Note that the bottom of the slider is value 0 and the top is its max value.
    //
    //    references:
    //        http://jqueryui.com/demos/slider/#slider-vertical
    var load_ = function load_() {
        if (jZoomSliderDiv) return; // if this viewport already has a zoom slider, return
        if (jVpDiv.find('.' + _defines2.default.clsDIVZOOMCTL).length === 0) {
            // if this viewport does NOT already have a FIXED zoom control, return
            // ('vpLoadZoomSlider(' + viewport.getImageId() + '): Fixed zoom control not present, cannot create slider.'); // eslint-disable-line no-undef
            return;
        }

        // first create an offscreen div that will contain the zoom slider
        jZoomSliderDiv = $('<div/>', { // build the div tag that contains the zoom slider
            'class': _defines2.default.clsDIVZOOMSLIDER + ' ' + _defines2.default.clsOVERLAY, // overlay class sets the z-index
            css: { 'left': _defines2.default.kDEF_TILE_POS_PX, 'top': _defines2.default.kDEF_TILE_POS_PX }
        });

        jZoomSliderDiv.slider({ // create the slider associated with this div
            orientation: 'vertical',
            range: 'min',
            min: _defines2.default.zoomSpecs.sliderMin,
            max: _defines2.default.zoomSpecs.sliderMax,
            value: 0,
            slide: function slide(event, ui) {
                // catch the slide event only to update the handle's text
                var jHandle = $(ui.handle);
                var maxVal = $(this).slider('option', 'max');
                var value = $(this).slider('value');
                var zoom = sliderValToZoom_(maxVal, value);
                zoom = (0, _helpers.roundToDecimals)(zoom); // keep zoom in proper resolution
                if (zoom !== viewport.getViewZoom()) {
                    isActive = true;
                    var mag = viewport.convertToMag(zoom); // display the latest mag
                    jHandle.text(mag + 'x');
                    viewport.zoomAbsolute(zoom); // execute the zoom
                }
            },
            stop: function stop(event, ui) {
                // catch the stop event to zoom the view
                viewport.zoomAbsolute(viewport.getViewZoom());
                isActive = false;
            }
        });

        var zoomHeight = jVpDiv.find('.' + _defines2.default.clsDIVZOOMCTL).height(); //get the height of the zoom button control
        var btnHeight = jVpDiv.find('.' + _defines2.default.clsDIVZOOMBTN).height();
        jZoomSliderDiv.height(zoomHeight - 2 * btnHeight); // set the slider height relative to the fixed zoom control

        var hWidth = jVpDiv.find('.' + _defines2.default.clsDIVZOOMBTNS).width(); // desired handle width is the width of the fixed zoom control
        var barWidth = Math.max(jZoomSliderDiv.width(), 9); // IE bar width is reported as 0 so insure there's a reasonable offset here
        var leftOffset = -Math.ceil((hWidth - barWidth) / 2);

        var jHandle = jZoomSliderDiv.find('.ui-slider-handle'); // set the width of the slider handle
        jHandle.css({ 'left': leftOffset + 'px' });

        jVpDiv.append(jZoomSliderDiv); // place the zoom slider div in the vp
        jZoomSliderDiv = jVpDiv.find('.' + _defines2.default.clsDIVZOOMSLIDER); // save for quick access

        layout.bottomOffset = btnHeight; // set the slider bottom offset to be about the middle of the fixed zoom control's bottom btn
        viewport.overLayout.add(layout); // and call into layout with parms to place the div

        isLoaded = true;
        self.update(); // update the text and position of the zoom slider handle
        self.show(true); // show/hide according to user preferences

        bindEvents_(); // add event handlers
        return;

        //..................................................
        // closure functions
        //............................................ bindEvents_()
        // bindEvents_ - This function adds the zoom slider control event handlers.
        //
        //    Note that by using the same namespace as the viewport when the
        //    viewport removes its events by namespace, these are also removed.

        function bindEvents_() {
            var namespace = viewport.eventNameSpaceGet();

            // show/hide zoom buttons on mode change
            $(_defines2.default.idHashROOT).on(_defines2.default.evMODECHANGE + namespace, function (e, parms) {
                // show is true if this is the image selected and not in a mode that I'm supposed to hide during
                var bshow = viewport.getImageIdx() == uScope.getSelImageIdx() && navModesImHiddenIn[parms.navMode] == undefined ? true : false;
                self.show(bshow);
            });

            viewport.renderer.addLayer({
                zoomChange: function zoomChange() {
                    if (!isActive) {
                        self.update();
                    }
                }
            });

            // show/hide zoom slider
            $(_defines2.default.idHashROOT).on(_defines2.default.evIMAGESELECTED + namespace, function (e, parms) {
                self.show(parms.uScopeIdx == viewport.getImageIdx());
            });

            // user preference update
            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSREADY + namespace, function (e, parms) {
                self.show(uScope.prefGet(_defines2.default.clsDIVZOOMSLIDER));

                reLayout(layout.precinct); // layout just this overlay's precinct
            });
            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFSET + namespace, function (e, parms) {
                // parms: {className: STR, value: bool}
                if (parms.className == _defines2.default.clsDIVZOOMSLIDER) {
                    self.show(parms.value);
                }
            });
            $(_defines2.default.idHashROOT).on(_defines2.default.evUSERPREFDEFAULTVISIBLE + namespace, function (e, parms) {
                uScope.prefSet(_defines2.default.clsDIVZOOMSLIDER, prefVisibleDef);
            });

            // mouse, ...
            jZoomSliderDiv.on('mousedown' + namespace, function (e) {
                // TODO: why was this here? -> viewport.setImageSelected();                     // inform uScope that this image is in focus
                return false; // prevent propigation to VP
            });
            jZoomSliderDiv.on('mouseleave' + namespace, function (e) {
                return false; // prevent propigation to VP
            });
            jZoomSliderDiv.on('mousemove' + namespace + ' mouseup' + namespace, function (e) {
                return true; // propigate necessary for slider operation
            });
        }
    };
    //............................................ update() local
    //    This function updates the text and position of the zoom slider handle.
    //        magValue: optional, if passed used as the magnfication value, otherwise the current view magnification is used
    this.update = function (magValue) {
        if (_defines2.default.ENABLEZOOMSLIDER == false) return;
        if (jZoomSliderDiv === undefined) return;
        var mag = magValue ? magValue : viewport.getViewMag();

        var jHandle = jZoomSliderDiv.find('.ui-slider-handle'); // set the mag on the slider handle
        jHandle.text(mag + 'x');

        var maxVal = $(jZoomSliderDiv).slider('option', 'max'); // and position the handle along the slider
        var value = sliderMagToVal_(maxVal, mag);
        $(jZoomSliderDiv).slider('value', value);
    };
    //............................................ sliderMagToVal_() local
    //    This function converts a passed magnification to the zoom slider's value.
    var sliderMagToVal_ = function sliderMagToVal_(maxVal, mag) {
        var value = Math.ceil(maxVal * Math.sqrt(mag / viewport.getMaximumMag()));
        value = maxVal - value;
        return value;
    };
    //............................................ sliderValToZoom_() local
    //    This function converts the current zoom slider value to its zoom.
    var sliderValToZoom_ = function sliderValToZoom_(maxVal, value) {
        value = maxVal - value;
        if (value > maxVal - 2) value = maxVal; // this control has a hard time reaching 0 (so when reversed it doesn't reach max)

        // compute the magnification for this slider position
        var mag = (value / maxVal * (value / maxVal) * viewport.getMaximumMag()).toFixed(1);
        if (mag < viewport.getFitMag()) mag = viewport.getFitMag();
        if (mag > viewport.getMaximumMag()) mag = viewport.getMaximumMag();
        var zoom = viewport.convertToZoom(mag); // compute the zoom
        return zoom;
    };

    //............................................ construction
    construct_();
}
module.exports = exports['default'];

/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 565:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 631:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(347);


/***/ })

},[631]);